function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import PropTypes from "prop-types";
import { OuiButton } from '../../../../src/components/button';
import { OuiContextMenuPanel, OuiContextMenuItem } from '../../../../src/components/context_menu';
import { OuiPopover } from '../../../../src/components/popover';
import { useIsWithinBreakpoints } from '../../../../src/services/hooks/useIsWithinBreakpoints';
import { OUI_THEMES } from '../../../../src/themes';
import { ThemeContext } from '../with_theme';
export var GuideThemeSelector = function GuideThemeSelector(_ref) {
  var rest = Object.assign({}, _ref);
  return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(GuideThemeSelectorComponent, _extends({
      context: context
    }, rest));
  });
};

// @ts-ignore Context has no type
GuideThemeSelector.propTypes = {
  context: PropTypes.any
};
var GuideThemeSelectorComponent = ({
  context
}) => {
  const isMobileSize = useIsWithinBreakpoints(['xs', 's']);
  const [isPopoverOpen, setPopover] = useState(false);
  const onButtonClick = () => {
    setPopover(!isPopoverOpen);
  };
  const closePopover = () => {
    setPopover(false);
  };
  const currentTheme = OUI_THEMES.find(theme => theme.value === context.theme) || OUI_THEMES[0];
  const getIconType = value => {
    return value === currentTheme.value ? 'check' : 'empty';
  };
  const items = OUI_THEMES.map(theme => {
    return <OuiContextMenuItem key={theme.value} icon={getIconType(theme.value)} onClick={() => {
      closePopover();
      context.changeTheme(theme.value);
    }}>
        {theme.text}
      </OuiContextMenuItem>;
  });
  const button = <OuiButton size="s" iconType="arrowDown" iconSide="right" color="ghost" minWidth={0} onClick={onButtonClick}>
      {isMobileSize ? 'Theme' : currentTheme.text}
    </OuiButton>;
  return <OuiPopover id="docsThemeSelector" repositionOnScroll button={button} isOpen={isPopoverOpen} closePopover={closePopover} panelPaddingSize="none" anchorPosition="downRight">
      <OuiContextMenuPanel size="s" items={items} />
    </OuiPopover>;
};
GuideThemeSelectorComponent.propTypes = {
  context: PropTypes.any
};